export var sizeValues = {
    small: '14px',
    default: '18px',
    medium: '1.5rem',
    large: '3rem',
    xlarge: '6rem',
};
export var getStyles = function (_a) {
    var size = _a.size, color = _a.color;
    return ({
        height: sizeValues[size || 'medium'],
        width: sizeValues[size || 'medium'],
        fill: color || 'var(--color-text-primary)',
        display: 'inline-block',
        flexShrink: 0,
        userSelect: 'none',
        lineHeight: '14px',
    });
};
//# sourceMappingURL=Icons.js.map